import { render, staticRenderFns } from "./ProjectZoneWiseReport.vue?vue&type=template&id=75fdbac8&"
import script from "./ProjectZoneWiseReport.vue?vue&type=script&lang=js&"
export * from "./ProjectZoneWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./ProjectZoneWiseReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VProgressLinear,VSpacer})
